import { Component, ElementRef, OnInit, ViewChild,Compiler } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptcha2Component } from 'ngx-captcha';
import { StudentapiService } from '../studentapi.service';
import * as $ from 'jquery';
import { NONE_TYPE } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { NavbarService } from '../navbar.service';

@Component({
  selector: 'app-hsscstudent',
  templateUrl: './hsscstudent.component.html',
  styleUrls: ['./hsscstudent.component.css']
})
export class HsscstudentComponent implements OnInit {

  // captcha
  selctform !: FormGroup;
  @ViewChild('captchaElem')
  captchaElem!: ReCaptcha2Component ;
  @ViewChild('langInput')
  langInput!: ElementRef;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;
  
  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type!: 'image' | 'audio';
  // end captcha
  
    isShowtableDiv = true;
    showDiv = {
      previous : false,
      current : false,
       next : true,
       hsscrslt: false,
       test:false
    }
    studentdata: any;
    // selctform !: FormGroup ;
    erno: any;
    stud: any;
    public temp: Object=false;
    dtOptions: DataTables.Settings = {};
    seat: any;
    stname: any;
    stream: any;
    hsscdata: any;
    ssub1: any;
    s1name: any;
    s2name: any;
    s3name: any;
    s4name: any;
    s5name: any;
    s6name: any;
    s7name: any;
    result:any;
    s1thext: any;
    s1thextg: any;
    s1thint: any;
    sb1x: any;
    sb1gr: any;
    s2thext: any;
    s2thextg: any;
    s2thint: any;
    sb2gr: any;
    sb2x: any;
    s3thext: any;
    s3thextg: any;
    s3thint: any;
    sb3gr: any;
    sb3x: any;
    s4thext: any;
    s4thextg: any;
    s4thint: any;
    sb4gr: any;
    sb4x: any;
    s5thext: any;
    s5thextg: any;
    s5thint: any;
    sb5gr: any;
    sb5x: any;
    s6thext: any;
    s6thextg: any;
    s6thint: any;
    sb6gr: any;
    sb6x: any;
    s7thext: any;
    s7thextg: any;
    s7thint: any;
  
    sb7x: any;
    sb7gr: any;
    ttl: any;
    exam: any;
    sb1th: any;
    sb1p: any;
    sb1pit: any;
    sb1prc: any;
    sb2p: any;
    sb2pit: any;
    sb2prc: any;
    sb3p: any;
    sb3pit: any;
    sb3prc: any;
    sb4p: any;
    sb4pit: any;
    sb4prc: any;
    sb5p: any;
    sb5pit: any;
    sb5prc: any;
    sb6p: any;
    sb6pit: any;
    sb6prc: any;
    sb7p: any;
    sb7pit: any;
    sb7prc: any;
    sb5th: any;
    sb5tgr: any;
    hsscselctform!: FormGroup;
    scode: null;
    teststud: any;
    sscrs: any;
    sscstudres: any;
    ftname: any;
    mtname: any;
    cdtbt: any;
    sbex1: any;
    sbex2: any;
    sbex3: any;
    sbex4: any;
    sbex5: any;
    sbex6: any;
    sbex7: any;
    sb1pgr: any;
    sb2th: any;
    sb3th: any;
    sb4th: any;
    sb6th: any;
    sb7th: any;
    sb2pgr: any;
    sb3pgr: any;
    sb4pgr: any;
    sb5pgr: any;
    sb6pgr: any;
    sb7pgr: any;
    sb1tgr: any;
    sb2tgr: any;
    sb3tgr: any;
    sb4tgr: any;
    sb6tgr: any;
    sb7tgr: any;
    s1thextmkr : any;
    sb1thmkr: any;
    sb1pmkr: any;
    s2thextmkr: any;
    sb2pmkr: any;
    sb2thmkr: any;
    s3thextmkr: any;
    sb3thmkr: any;
    sb3pmkr: any;
    s4thextmkr: any;
    sb4thmkr: any;
    sb4pmkr: any;
    s5thextmkr: any;
    sb5thmkr: any;
    sb5pmkr: any;
    s6thextmkr: any;
    sb6thmkr: any;
    sb6pmkr: any;
    s7thextmkr: any;
    sb7thmkr: any;
    sb7pmkr: any;
    isDisabled = true;
    isDisabled_ssc = true;
    date = new Date();
    latest_date: any;
    captcha: any;
    captcha_answer: any;
    num_one: any;
    num_two: any;
    isShown = true;
    latest_time: any;
    timedata: any;
    resultdate: any;
    resulttime: any;
    studenthsscdata: any;
    course: any;
    enable: any;
    enable_ssc: any;
    s1mks: any;
    s2mks: any;
   
  
    constructor(public datepipe: DatePipe,public formbuilder:FormBuilder,public router:Router, private api:StudentapiService) { }
  
    ngOnInit(): void {
  
      
      // this.nav.show();
      this.selctform = this.formbuilder.group({
        fname:['', Validators.pattern('^[a-zA-Z ]*$')],
        cdtbt:[''],
        seat:[''],
        scode:[''],
        exam:[''],
        sb1x:[''],
        captcha:['',Validators.required],
        recaptcha: ['', Validators.required]
      });
     
  
      this.latest_date = this.datepipe.transform(this.date, 'dd-MM-yyyy');
       this.latest_time = this.datepipe.transform(this.date, 'H:mm a');
      
      this.api.post('/StudentApi/setting',{}).subscribe((res:any)=>{
        this.timedata = res.Data[0];
          this.enable = this.timedata.enable;
          this.enable_ssc = this.timedata.enable_ssc;
        // console.log(this.enable);
        if(this.enable == 'Yes')
        {
          this.isDisabled = false;
        }
        else{
          this.isDisabled = true;
        }
  
        if(this.enable_ssc == 'Yes')
        {
          this.isDisabled_ssc = false;
        }
        else{
          this.isDisabled_ssc = true;
        }
  
  
      });
  
  
      // for number captcha
  
      this.num_one = Math.floor((Math.random() * 10) + 1);
      this.num_two =Math.floor((Math.random() * 10) + 1);
      this.captcha_answer =  this.num_one + this.num_two;
      //  console.log(this.captcha_answer);
  
    }
  
    // used for google captcha site
    siteKey: string="6LdVAlUaAAAAAOKqf4EZ5ZfTBlrUsWWRAa_jMrZn";
    handleSuccess(data:any) {
      // console.log(data);
    }
     
  
    activeTab = '';
    toggleDisplayDiv(activeTab:any) {
      
      // ---- for hide hssc and ssc button ---
      // this.isShown = ! this.isShown;
      // ---- for hide hssc and ssc button ---
      this.showDiv.previous = !this.showDiv.previous;
      this.showDiv.current = false;
      this.showDiv.next = false;
      this.showDiv.hsscrslt = false
      // this._compiler.clearCache();
      this.activeTab = activeTab;
    }
  
    hsscResult(activeTab: any){
      // this.isShown = ! this.isShown;
      // this.router.navigate(['/sscstudents']);
      this.showDiv.next = !this.showDiv.next;
      // this.showDiv.previous = false;
      // this.showDiv.current = false;
      // this.showDiv.hsscrslt = false
      // this._compiler.clearCache();
      this.activeTab = activeTab;
    }
  
    keyPressAlpha(event:any) {
  
      var inp = String.fromCharCode(event.keyCode);
  
      if (/[a-z A-Z]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        alert('Please Enter Alphabet Only..! Ex:Your Name');
        return false;
      }
    }
  
  
  
    // for hssc result
    onStudentresulthssc(){
  
      let stud :{seat:any,cdtbt:any,scode:any,fname:any} ={
        
        seat : this.selctform.controls.seat.value,
        cdtbt : this.selctform.controls.cdtbt.value,
        scode : this.selctform.controls.scode.value,
        fname : this.selctform.controls.fname.value,
        
      }
      // console.log(stud);
      // alert('hssc click');
      if(stud.seat == "")
        {
          alert('Please fill all information');
        
        }
        else if(this.selctform.controls.recaptcha.value == "")
        {
            alert('Please Select Captcha');
        }
        else
        {
          this.api.post('/StudentApi/studentresultcet',stud).subscribe((res:any)=>{
            // console.log(res["Data"]);
   
            if (res['Data']) {
          //     let msg = res['Msg'];
          // alert(msg);
             this.showDiv.hsscrslt = !this.showDiv.hsscrslt;
             this.showDiv.previous = false;
             this.showDiv.next = false
             // alert('Please correct the subject selection and click Save ! ');
             this.studenthsscdata = res['Data'];
           this.seat = this.studenthsscdata[0].seat;
           this.stname = this.studenthsscdata[0].stname;
           this.stream = this.studenthsscdata[0].stream;
           this.s1name = this.studenthsscdata[0].s1name;
           this.s2name = this.studenthsscdata[0].s2name;
           this.s1mks = this.studenthsscdata[0].s1mks;
           this.s2mks = this.studenthsscdata[0].s2mks;
  
           this.exam  = this.studenthsscdata[0].exam;
           this.ttl  = this.studenthsscdata[0].total;
           this.result = this.studenthsscdata[0].result;
           
           this.ftname = this.studenthsscdata[0].ftname;
           this.mtname = this.studenthsscdata[0].mtname;
           this.cdtbt = this.studenthsscdata[0].cdtbt;
            this.selctform.reset();
             // return;
         }
         else{
           
          //  alert('Please Check Information');
          let msg = res['Msg'];
          alert(msg);
           this.selctform.reset();
           return;
         }
           
           
         },
         err=>{
         
          alert('ERROR! Please Fill All valid Details');
           
           window.location.replace('/#/'); 
           
   
         });
  
        }
  
     
    }
  
   
  

}
